import { Box, Text } from '@medly-components/core';
import { centerAligned } from '@medly-components/utils';
import styled, { css } from 'styled-components';

export const MapsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow-x: hidden;
    gap: 4rem;
    padding: 2.4rem 0;

    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        padding: 4rem 0;
    }
`;

export const Section = styled.div`
    padding: 0 3.2rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        padding: 0 2.6rem;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        padding: 0 2.4rem;
    }
`;

export const Banner = styled(Section)`
    display: flex;
    gap: 1.8rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        flex-direction: column;
    }
`;

export const Maps = styled(Section)`
    display: flex;
    flex-direction: column;
    gap: 4rem;
`;

export const MapsContent = styled(Text)`
    color: ${({ theme }) => theme.colors.grey[700]};
    max-width: 75%;
    margin-top: 1.2rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.L.min}px) {
        max-width: 80%;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        max-width: 100%;
    }
`;

export const TakeAppTourWrapper = styled.div`
    padding: 1rem 2rem;
    background-color: ${({ theme }) => theme.colors.white};
    border: 0.1rem solid ${({ theme }) => theme.colors.grey[300]};
    border-radius: 0.8rem;
    cursor: pointer;
    width: max-content;
    ${Text.Style} {
        margin-left: 0.8rem;
    }
    ${centerAligned('flex')}
`;

export const sectionWrapperStyles = css`
    padding: 1.5rem;
    border-radius: 0.8rem;
`;

export const LegendsWrapper = styled(Box)`
    ${sectionWrapperStyles};
    flex-direction: column;
    background-color: ${({ theme }) => theme.colors.white};
`;

export const ContactUsWrapper = styled(Box)`
    ${sectionWrapperStyles};
    background-color: ${({ theme }) => theme.colors.white};
    gap: 1.5rem;
    align-items: center;

    img {
        width: 8rem;

        @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
            width: 5.6rem;
        }
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const ContactUsDescription = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    gap: 1rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        width: 100%;
    }
`;

export const DisclaimerWrapper = styled.div`
    display: flex;
    gap: 0.8rem;
    flex-direction: column;
    width: 70%;

    span:last-child {
        font-size: 0.8rem;
        line-height: 1rem;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        width: 100%;
    }
`;
